export enum CareerType {
	Development = "Development",
	Production = "Production",
	Office = "Office",
	SalesAndManagement = "SalesAndManagement",
}
